import React, {useEffect, useState} from 'react';
import localization from 'assets/localization/localization';
import useLatLng from 'hooks/uselatlng/uselatlng';
import {Button, FormGroup} from 'react-bootstrap';
import GoogleMapReact from 'google-map-react';
import {toast} from "react-toastify";
import './main.css';
import DropDownInput from 'components/sales/Input/dropDownInput/dropDownInput';
import TextAreaInput from 'components/sales/Input/textAreaInput/textAreaInput';
import {Link} from "react-router-dom";

const DistanceCalculator = (
    {
        task_id=null,
        getSiteData,
        siteData,
        calculateDistance,
        siteId,
        moduleType,
        to,
        isMapShow = true,
        flag = null,
        onSuccess = null
    }
) => {

    let markers = [];
    const [mapLocation, setMapLocation] = useState({
        address: 'Delhi',
        lat: 0,
        lng: 0,
    });
    const [isAllow, setIsAllow] = useState(false);
    const [isLocationError, setIsLocationError] = useState(false);
    // Layer 3 duplicate-prevention: disable button while request is in-flight (spec §0).
    const [isSubmitting, setIsSubmitting] = useState(false);
    const islatlng = useLatLng();
    const [engAt, setEngAt] = useState(1)
    const [showQuestionPopup, setQuestionPopUp] = useState(false)
    const [comments, setComments] = useState("")
    const [cteExactLocation, setCteExactLocation] = useState("")
    const [siteClosingState, setSiteClosingState] = useState(0)
    const [validateMsg, setValidateMsg] = useState("")
    const [totalDistance, setDistance] = useState("")
    const [siteLocation, setSiteLocaation] = useState({
        'lat': 0,
        'long': 0
    })

    useEffect(() => {
        (async () => {
            delete siteLocation.lat
            setDistance("")
            await getSiteData(siteId)
        })();

    }, []);


    useEffect(() => {
        if (islatlng === false) {
            setIsAllow(true);
        } else {
            setIsAllow(false);
        }
        var lati = Number(islatlng?.lat);
        var langi = Number(islatlng?.lng);
        if (!isNaN(lati) && !isNaN(langi)) {
            setMapLocation({
                address: 'Delhi6',
                lat: Number(islatlng?.lat),
                lng: Number(islatlng?.lng),
            });
        }
    }, [islatlng]);

    const parseCoord = (value) => {
        const n = Number(value);
        return Number.isFinite(n) ? n : null;
    };

    useEffect(() => {
        if (siteData === undefined || siteData === null || Object.keys(siteData).length === 0) {
            return;
        }
        setSiteLocaation({'lat': siteData['lead']['latitude'], 'long': siteData['lead']['longitude']});

        const userLat = parseCoord(islatlng?.lat);
        const userLng = parseCoord(islatlng?.lng);
        const siteLat = parseCoord(siteData['lead']['latitude']);
        const siteLng = parseCoord(siteData['lead']['longitude']);

        if (userLat === null || userLng === null || siteLat === null || siteLng === null) {
            setDistance("");
            return;
        }

        const distance = calcCrow(userLat, userLng, siteLat, siteLng);
        if (!Number.isFinite(distance)) {
            setDistance("");
            return;
        }
        distance > 1 ? setEngAt(2) : setEngAt(1);
        setDistance(distance);
    }, [islatlng?.lat, islatlng?.lng, siteData])

    // useEffect(()=>{
    //     setSiteLocaation({'lat':siteLocation.lat, 'long':siteLocation.long})
    // }, [siteLocation.lat])

    const handleSubmitData = async () => {
        // Guard: prevent rapid re-calls / double-clicks (spec §0 Layer 3).
        if (isSubmitting) return;

        if (isAllow) {
            alert(localization.locationPermission);
        }

        let isBreak = handleSiteStateClose(1)
        if (isBreak) {
            return true
        }

        const data = {
            task_id:task_id,
            lat: islatlng?.lat,
            long: islatlng?.lng,
            eng_at: engAt === 1 ? 'Site' : 'Remotely',
            site_id: siteId,
            site_lat: siteData['lead']['latitude'],
            site_long: siteData['lead']['longitude'],
            module_type: moduleType,
            flag: flag ?? null
        };
        if (moduleType === 'cte_ticket' && task_id && engAt === 2 && cteExactLocation) {
            data['check_in_remark'] = cteExactLocation;
        }

        if (engAt === 2) {
            if (moduleType === 'cte_ticket' && !cteExactLocation?.trim()) {
                setValidateMsg("Please select where you are exactly.");
                toast.error("Please select where you are exactly.");
                return true;
            }
            data['site_state_close_via'] = siteClosingState === 1 ? localization.throughVideoCall : localization.throughVoiceCall
            data['comments'] = comments
        }else if(engAt === 1 && !isMapShow){
            // will work only daily task activities and site_state_close_via value will be on site
            data['site_state_close_via'] = "On Site"
            data['comments'] = comments
        }

        setIsSubmitting(true);
        try {
            const response = await calculateDistance(data);
            if (response === true) {
                // Success
                if (typeof onSuccess === 'function') {
                    await onSuccess();
                }
                if (!isMapShow) {
                    window.location.reload();
                }
                return true;
            }

            // Conflict: already checked in to another ticket (CTE only).
            if (response?.conflict === true && moduleType === 'cte_ticket') {
                const conflictData = response.data;
                const businessName = conflictData?.active_client_name?.trim();
                const businessSuffix = businessName ? ` (${businessName})` : '';
                const ticketLabel = conflictData?.active_ticket_id
                    ? `ticket #${conflictData.active_ticket_id}${businessSuffix}`
                    : `site check-in #${conflictData?.active_checkin_id}${businessSuffix}`;
                const confirmed = window.confirm(
                    `You are already checked in to ${ticketLabel}. Do you want to check out from there and check in here?`
                );
                if (confirmed) {
                    // Retry with flag = "force"
                    const forced = await calculateDistance({ ...data, flag: 'force' });
                    if (forced === true) {
                        if (typeof onSuccess === 'function') {
                            await onSuccess();
                        }
                        if (!isMapShow) {
                            window.location.reload();
                        }
                        return true;
                    }
                }
                return false;
            }

            // Any other failure — toast already shown by network layer
            return false;
        } finally {
            setIsSubmitting(false);
        }
    };

    function renderMarkers(map, maps) {
        let siteLeadData = JSON.parse(localStorage.getItem("distance_cal_site_data"))
        markers = [ // Just an example this should probably be in your state or props.
            {
                title: "eng site",
                position: {lat: Number(islatlng?.lat), lng: Number(islatlng?.lng)}
            }
        ];

        if (siteLocation.lat !== undefined) {
            markers.push({
                title: "Site",
                position: {
                    lat: Number(siteLocation.lat),
                    lng: Number(siteLocation.long)
                }
            })
            {
                markers.map((marker1, index) => (
                    new maps.Marker({
                        key: index,
                        position: marker1.position,
                        name: marker1.name,
                        map,
                        title: (marker1.title == 'eng site') ? 'You are here!' : 'Site',
                        icon: {url: (marker1.title == 'eng site') ? "http://maps.google.com/mapfiles/ms/icons/blue-dot.png" : "http://maps.google.com/mapfiles/ms/icons/red-dot.png"}

                    })
                ))
            }
            ;
        }

    }

    useEffect(() => {
        if (engAt === 2) {
            setQuestionPopUp(true)
        }

        // check if user is on site or remotely it's must be open to track daily activities task
        if (isMapShow === false) {
            setQuestionPopUp(true)
        }
    }, [engAt])

    const handleSiteStateClose = (state) => {
        if (state === 1) {

            // this will work only for daily task activities
            if (engAt === 1) {
                if (comments.trim() === "" && !isMapShow) {
                    setValidateMsg("Comments is required if you are working as remotely.")
                    return true
                }else if(comments.trim() !== "" && !isMapShow){
                    setQuestionPopUp(false)
                }
            }


            if (engAt === 2) {
                if (comments.trim() === "") {
                    setValidateMsg("Comments is required if you are working as remotely.")
                    toast.error("Comments is required if you are working remotely.");
                    return true
                } else if (siteClosingState === 0) {
                    setValidateMsg("Closing this site stage is required if you are working as remotely.")
                    toast.error("Please select site close via (Video/Voice) for remote check-in.");
                    return true
                } else {
                    setQuestionPopUp(false)
                    setValidateMsg("")
                }
            }
        } else {
            setQuestionPopUp(false)
        }
    }

    const toRad = (Value) => {
        return Value * Math.PI / 180
    }

    const calcCrow = (lat1, lon1, lat2, lon2) => {
        var R = 6371 // km
        var dLat = toRad(lat2 - lat1)
        var dLon = toRad(lon2 - lon1)
        var lat1 = toRad(lat1)
        var lat2 = toRad(lat2)

        var a = Math.sin(dLat / 2) * Math.sin(dLat / 2) +
            Math.sin(dLon / 2) * Math.sin(dLon / 2) * Math.cos(lat1) * Math.cos(lat2)
        var c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a))
        var d = R * c
        return d
    }

    return (
        <>
            <link rel="stylesheet" href="https://use.fontawesome.com/releases/v5.4.1/css/all.css"
                  integrity="sha384-5sAR7xN1Nv6T6+dT2mhtzEpVJvfS3NScPQTrOxhwjIuvcA67KV2R5Jz6kr4abQsz"
                  crossOrigin="anonymous"/>
            <link href="https://fonts.googleapis.com/css?family=Roboto:300,400,500,700" rel="stylesheet"></link>

            <form className="attForm">

                        {Number.isFinite(totalDistance) &&
                            <h5 style={{"color": "#6c7ae0"}}>you are {Number(totalDistance).toFixed(2)} KM away from
                                site</h5>}
                        <div className='row pointer-where-are-you'>
                            <div className="col-m-6">
                                <img
                                    src="http://maps.google.com/mapfiles/ms/icons/blue-dot.png"/> : <strong>You{"\u00a0\u00a0"} </strong>
                                {islatlng === null
                                    ? '(Fetching location…)'
                                    : islatlng === false
                                        ? '(Location permission denied)'
                                        : `(Lat: ${islatlng?.lat ?? '–'}${"\u00a0\u00a0"}Long: ${islatlng?.lng ?? '–'})`}
                            </div>
                            <div className="col-m-6">
                                <img
                                    src="http://maps.google.com/mapfiles/ms/icons/red-dot.png"/> : <strong>Site {"\u00a0\u00a0"}</strong>
                                {siteData !== undefined && siteData !== null && Object.keys(siteData).length > 0 &&
                                    <>
                                        (Lat: {siteData['lead']['latitude']} {"\u00a0\u00a0"} Long: {siteData['lead']['longitude']})
                                    </>
                                }
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-12">
                                <DropDownInput
                                    label={localization.whereAreYou}
                                    data={[{'id': 1, name: localization.iAmAtSite}, {
                                        id: 2,
                                        name: localization.iAmAtRemotely
                                    }]}
                                    getValueById={engAt}
                                    required
                                    isStarRequired={true}
                                    errorMsg={localization.requiredErrorMg}
                                    getIdValue={(val) => setEngAt(val.id)}
                                    disabled={true}
                                />
                            </div>
                            {moduleType === 'cte_ticket' && engAt === 2 &&
                                <div className="col-12">
                                    <DropDownInput
                                        label={"Where are you exactly"}
                                        data={[
                                            {id: 1, name: 'At Head Office'},
                                            {id: 2, name: 'At Regional Office'},
                                            {id: 3, name: 'At Home'}
                                        ]}
                                        required
                                        isStarRequired={true}
                                        errorMsg={localization.requiredErrorMg}
                                        getValueById={
                                            cteExactLocation === 'At Head Office' ? 1 :
                                            cteExactLocation === 'At Regional Office' ? 2 :
                                            cteExactLocation === 'At Home' ? 3 : ''
                                        }
                                        getIdValue={(val) => {
                                            if (!val?.value) return;
                                            setCteExactLocation(val.value);
                                        }}
                                    />
                                </div>
                            }

                                {validateMsg &&
                                    <div>
                                        <p style={{"color": "red",'paddingLeft':'18px'}}>{validateMsg}</p>
                                    </div>
                                }
                                {engAt === 2 &&
                                    <>
                                        <h5 style={{"color": "#6c7ae0",'paddingLeft':'18px'}}>Please give answer of this following question
                                            before proceed.</h5>
                                        <div className="col-12">
                                            <DropDownInput
                                                label={localization.howAreYouClosingThisSiteStage}
                                                data={[{'id': 1, name: localization.throughVideoCall}, {
                                                    id: 2,
                                                    name: localization.throughVoiceCall
                                                }]}
                                                required
                                                isStarRequired={true}
                                                errorMsg={localization.requiredErrorMg}
                                                getValueById={siteClosingState}
                                                getIdValue={(val) => {
                                                    if (!val?.id) return;
                                                    setSiteClosingState(val.id);
                                                }}
                                            />
                                        </div>
                                    </>
                                }
                                {!isMapShow && <div className="col-12">
                                    <TextAreaInput
                                        type="text"
                                        rows={6}
                                        label={localization.addRemark}
                                        value={comments}
                                        inputValue={comments}
                                        required
                                        isStarRequired={true}
                                        handleChange={(e) => {
                                            setComments(e.target.value)
                                        }}
                                        className={""}
                                    />
                                </div>
                                }
                            {isMapShow && engAt === 2 &&
                                <div className="col-12">
                                    <TextAreaInput
                                        type="text"
                                        rows={6}
                                        label={localization.addRemark}
                                        value={comments}
                                        inputValue={comments}
                                        required
                                        isStarRequired={true}
                                        handleChange={(e) => {
                                            setComments(e.target.value)
                                        }}
                                        className={""}
                                    />
                                </div>
                            }


                            <div className="col-3">
                                <Button
                                    className="btn-sm"
                                    onClick={() => handleSubmitData()}
                                    disabled={isLocationError || isSubmitting}
                                >
                                    {localization.submit}
                                </Button>
                            </div>
                        </div>

                {/*{isRemarkPopupShow && showQuestionPopup &&*/}
                {/*    <div className="popup-box-question">*/}
                {/*        <div className="box1">*/}
                {/*                <>*/}
                {/*                {isMapShow ?*/}
                {/*                    <Link*/}
                {/*                        to={to}*/}
                {/*                        className="btn btn-primary mb-4"*/}
                {/*                        style={{*/}
                {/*                            'cursor': 'pointer',*/}
                {/*                            'float': 'right',*/}
                {/*                            'border': '0px',*/}
                {/*                            'boxShadow': 'none !important',*/}
                {/*                            'position': 'relative',*/}
                {/*                            'height': '10px'*/}
                {/*                        }}*/}
                {/*                    >*/}
                {/*                        x*/}
                {/*                    </Link>  :*/}
                {/*                    <Link*/}
                {/*                        to={to}*/}
                {/*                        className="btn btn-primary mb-4"*/}
                {/*                        style={{*/}
                {/*                            'cursor': 'pointer',*/}
                {/*                            'float': 'right',*/}
                {/*                            'border': '0px',*/}
                {/*                            'boxShadow': 'none !important',*/}
                {/*                            'position': 'relative',*/}
                {/*                            'height': '10px'*/}
                {/*                        }}*/}
                {/*                        onClick={!isMapShow ? () => {setQuestionPopUp(false)} : () => {}}*/}
                {/*                    >*/}
                {/*                        x*/}
                {/*                    </Link>*/}
                {/*                }*/}

                {/*                    {totalDistance !== 'NaN' &&*/}
                {/*                        <h5 style={{"color": "#6c7ae0"}}>you are {Number(totalDistance).toFixed(2)} KM*/}
                {/*                            away from site({engAt === 1 ? "on site" : "Remotely"})</h5>}*/}
                {/*                    <div className='row pointer-where-are-you'>*/}
                {/*                        <div className="col-m-6">*/}
                {/*                            <img*/}
                {/*                                src="http://maps.google.com/mapfiles/ms/icons/blue-dot.png"/> : <strong>You{"\u00a0\u00a0"} </strong>*/}
                {/*                            (Lat: {islatlng?.lat} {"\u00a0\u00a0"} Long: {islatlng?.lng})*/}
                {/*                        </div>*/}
                {/*                        <div className="col-m-6">*/}
                {/*                            <img*/}
                {/*                                src="http://maps.google.com/mapfiles/ms/icons/red-dot.png"/> : <strong>Site {"\u00a0\u00a0"}</strong>*/}
                {/*                            {siteData !== null && Object.keys(siteData).length > 0 &&*/}
                {/*                                <>*/}
                {/*                                    (Lat: {siteData['lead']['latitude']} {"\u00a0\u00a0"} Long: {siteData['lead']['longitude']})*/}
                {/*                                </>*/}
                {/*                            }*/}
                {/*                        </div>*/}
                {/*                    </div>*/}
                {/*                </>*/}
                {/*            <div className="row row-style">*/}

                {/*                {validateMsg &&*/}
                {/*                    <div>*/}
                {/*                        <p style={{"color": "red"}}>{validateMsg}</p>*/}
                {/*                    </div>*/}
                {/*                }*/}
                {/*                {engAt === 2 &&*/}
                {/*                    <>*/}
                {/*                        <h5 style={{"color": "#6c7ae0"}}>Please give answer of this following question*/}
                {/*                            before proceed.</h5>*/}
                {/*                        <div className="col-12">*/}
                {/*                            <DropDownInput*/}
                {/*                                label={localization.howAreYouClosingThisSiteStage}*/}
                {/*                                data={[{'id': 1, name: localization.throughVideoCall}, {*/}
                {/*                                    id: 2,*/}
                {/*                                    name: localization.throughVoiceCall*/}
                {/*                                }]}*/}
                {/*                                required*/}
                {/*                                isStarRequired={true}*/}
                {/*                                errorMsg={localization.requiredErrorMg}*/}
                {/*                                getIdValue={(val) => setSiteClosingState(val.id)}*/}
                {/*                            />*/}
                {/*                        </div>*/}
                {/*                    </>*/}
                {/*                }*/}
                {/*                <div className="col-12">*/}
                {/*                    <TextAreaInput*/}
                {/*                        type="text"*/}
                {/*                        rows={6}*/}
                {/*                        label={localization.addRemark}*/}
                {/*                        value={comments}*/}
                {/*                        inputValue={comments}*/}
                {/*                        required*/}
                {/*                        isStarRequired={true}*/}
                {/*                        handleChange={(e) => {*/}
                {/*                            setComments(e.target.value)*/}
                {/*                        }}*/}
                {/*                        className={""}*/}
                {/*                    />*/}
                {/*                </div>*/}
                {/*                <div className="col-3">*/}
                {/*                    <Button*/}
                {/*                        className="btn-sm"*/}
                {/*                        onClick={() => handleSiteStateClose(1)}*/}
                {/*                        disabled={isLocationError}*/}
                {/*                    >*/}
                {/*                        {localization.save}*/}
                {/*                    </Button>*/}
                {/*                </div>*/}
                {/*            </div>*/}
                {/*        </div>*/}
                {/*    </div>*/}
                {/*}*/}
            </form>
        </>
    );
};

export default DistanceCalculator;
